export const gqlErrors = {
  messages: {
    loginOTP: "OTP verification required",
    email: "Validation failed: Email is invalid",
    verifyOTP: "Invalid OTP, Please check the OTP",
    accessDenied: "Your access has been revoked, please contact admin",
    couponCodeInvalid: "Invalid Coupon",
    couponCodeAlreadyPresent: "Coupon already added to cart",
    cartNotFound: "Cart not found",
  },
};
